module.exports = __webpack_public_path__ + "static/media/berry-frost@3x.7338dd56.png";